import {Paragraph} from "@reside/ui";
import {FunctionComponent} from "react";

export const SlideParagraph: FunctionComponent = ({children}) => (
  <Paragraph fontSize="1.25em" lineHeight="1.75em">
    {children}
  </Paragraph>
);
